import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "general/my-user"

class service {

    get() {
        return http.get(path).then(response => {
            return response.data
        })
    }

    getCustomerServiceCenterToken() {
        return http.post(path + "/getCustomerServiceCenterToken").then(async (response) => {
            return response.data
        })
    }

    setPreference(type,value){

        const preference = {
            [type] : value,
        }

        return http.put(path + "/preference",preference).then(response => {
            return response.data
        });
    }


}

export default new service();

